import api from './api';
import { Tarea, CreateTareaForm, UpdateTareaForm, ApiResponse } from '../types';

export const tareaService = {
  async getTareas(): Promise<ApiResponse<Tarea[]>> {
    try {
      const response = await api.get('/Tareas');
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al cargar las tareas',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async getTareasActivas(): Promise<ApiResponse<Tarea[]>> {
    try {
      const response = await api.get('/Tareas/activas');
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al cargar las tareas activas',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async createTarea(tarea: CreateTareaForm): Promise<ApiResponse<Tarea>> {
    try {
      // Validaciones del lado del cliente
      if (!tarea.nombre?.trim()) {
        return { 
          success: false, 
          message: 'El nombre de la tarea es requerido',
          errors: ['El nombre de la tarea es requerido']
        };
      }

      if (tarea.nombre.length > 200) {
        return { 
          success: false, 
          message: 'El nombre de la tarea no puede exceder 200 caracteres',
          errors: ['El nombre de la tarea no puede exceder 200 caracteres']
        };
      }

      if (tarea.descripcion && tarea.descripcion.length > 500) {
        return { 
          success: false, 
          message: 'La descripción no puede exceder 500 caracteres',
          errors: ['La descripción no puede exceder 500 caracteres']
        };
      }

      const response = await api.post('/Tareas', tarea);
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al crear la tarea',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async updateTarea(id: number, tarea: UpdateTareaForm): Promise<ApiResponse<Tarea>> {
    try {
      // Validaciones del lado del cliente
      if (!tarea.nombre?.trim()) {
        return { 
          success: false, 
          message: 'El nombre de la tarea es requerido',
          errors: ['El nombre de la tarea es requerido']
        };
      }

      if (tarea.nombre.length > 200) {
        return { 
          success: false, 
          message: 'El nombre de la tarea no puede exceder 200 caracteres',
          errors: ['El nombre de la tarea no puede exceder 200 caracteres']
        };
      }

      if (tarea.descripcion && tarea.descripcion.length > 500) {
        return { 
          success: false, 
          message: 'La descripción no puede exceder 500 caracteres',
          errors: ['La descripción no puede exceder 500 caracteres']
        };
      }

      const response = await api.put(`/Tareas/${id}`, tarea);
      return { success: true, data: response.data };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al actualizar la tarea',
        errors: error.response?.data?.errors || []
      };
    }
  },

  async deleteTarea(id: number): Promise<ApiResponse<void>> {
    try {
      await api.delete(`/Tareas/${id}`);
      return { success: true };
    } catch (error: any) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Error al eliminar la tarea',
        errors: error.response?.data?.errors || []
      };
    }
  },
}; 